import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthStateService } from '@core/services/auth/auth-state';

export const authGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthStateService);
  const router = inject(Router);

  if (auth.isAuthenticated()) {
    return true;
  }

  const is2fa = state.url === '/2fa';
  const has2faClaim = auth.getJwtClaim('2FA_Pending');
  console.log(has2faClaim);

  if (is2fa && !has2faClaim) {
    return router.createUrlTree(['/login']);
  }

  if (has2faClaim) return true;

  return router.createUrlTree(['/login'], {
    queryParams: { returnUrl: state.url },
  });
};
